import * as React from "react";
import { cx } from "../util.js";

export interface ProjectCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Project/book title (shown on the cover). */
  title: string;
  /** Genre chip text. */
  genre?: string;
  /** Metadata line, e.g. "643 words · 1 chapter · 3 scenes". */
  meta?: React.ReactNode;
  /** CSS background for the cover (gradient or color). Defaults to the brand gradient. */
  cover?: string;
  /** Optional cover image URL (overrides `cover`). */
  coverSrc?: string;
}
/** Library project card with a serif-titled cover. Whole card is the click target. */
export function ProjectCard({ title, genre, meta, cover, coverSrc, className, onKeyDown, onKeyUp, ...rest }: ProjectCardProps) {
  return (
    <div className={cx("ip-project", className)} role="button" tabIndex={0} {...rest}
      onKeyDown={event => {
        onKeyDown?.(event);
        if (event.defaultPrevented || event.target !== event.currentTarget) return;
        if (event.key === " ") event.preventDefault();
        if (event.key === "Enter" && !event.repeat) { event.preventDefault(); event.currentTarget.click(); }
      }}
      onKeyUp={event => {
        onKeyUp?.(event);
        if (!event.defaultPrevented && event.target === event.currentTarget && event.key === " ") {
          event.preventDefault(); event.currentTarget.click();
        }
      }}
    >
      <div
        className="ip-project-cover"
        style={coverSrc ? { backgroundImage: `url(${coverSrc})`, backgroundSize: "cover" } : cover ? { background: cover } : undefined}
      >
        {!coverSrc && <div className="ip-project-title">{title}</div>}
      </div>
      <div className="ip-project-body">
        {genre && <span className="ip-chip">{genre}</span>}
        <div className="ip-project-name">{title}</div>
        {meta && <div className="ip-project-meta">{meta}</div>}
      </div>
    </div>
  );
}
